import actions from './actions';
import mutations from './mutations';

const getters = {
  isInternalReport: (state) => state.reportType === 'internal',
};

const reportsModule = {
  namespaced: true,
  state() {
    return {
      excludedItems: [],
      enableExcludeItems: false,
      reportType: 'internal',
      reportView: {},
      galleryImages: [],
      gallaryStartIndex: 0,
    };
  },
  actions,
  mutations,
  getters,
};

export default reportsModule;
